import { Subject } from 'rxjs';
import { UserPageService } from './../user-page/user-page.service';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';
import { Component, OnInit, Output, EventEmitter, ViewChild, AfterViewInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserRoleService } from 'src/app/services/user-role.service';
import { Employee } from 'src/app/data/models/employee.model';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import { ToastrService } from 'ngx-toastr';
import { MatStepper } from '@angular/material/stepper';
import { CompanyService } from '../../../../services/company.service';
// import * as Roles from '../../../../data/constants/roles';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Address } from 'src/app/data/models/address.model';
import { CountryApiService } from 'src/app/modules/petitioner/services/country.service';
import { PrimaryContactConfirmationComponent } from '../primary-contact-confirmation/primary-contact-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ManageUserComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output()
  selectedCompany: EventEmitter<{}> = new EventEmitter();

  @Output()
  onClickSave: EventEmitter<{}> = new EventEmitter();
  

  listCountry: [];
  listStates: any[] = [];
  phoneTypeList: ReferenceLibrary[];
  listCompany: any[];
  listRole: object[];
  editedUser;
  companyName;
  showDdr: boolean;

  employee = new Employee({
    email: '',
    firstName: '',
    lastName: '',
    middleName: '',
    roleIds: [],
    address: new Address({})
  });
  isDisabled = false;
  isValidFormSubmitted = false;
  // @ViewChild('userForm', { static: false }) userForm: NgForm;
  observableSubscription$ = new Subject();
  userForm: FormGroup;
  parameterId;
  isIncludeAssociate: boolean;
  isPrimaryContact: boolean;
  isEnabledPrimary: boolean=false;
  userSignatory: boolean=false;
  currentUserId = null;
  currentCompanyId = null;
  currentUserSignature = null;
  fileName: any;
  displayList: boolean;
  beforeDelete: boolean = false;

  constructor(
    private cacheCountryService: CacheCountryService,
    private referenceLibraryService: ReferenceLibraryService,
    private userRoleService: UserRoleService,
    private toastr: ToastrService,
    private stepper: MatStepper,
    private companyApiService: CompanyService,
    private userPageService: UserPageService,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: CountryApiService,
    public dialog: MatDialog,
  ) {
    this.listCountry = [];
    this.referenceLibraryService
      .getReferenceData('PHON')
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ReferenceLibrary[]) => {
        this.phoneTypeList = response;
      });
    this.userForm = new FormGroup({
      companyId: new FormControl(null, Validators.required),
      firstName: new FormControl(null, Validators.required),
      lastName: new FormControl(null, Validators.required),
      middleName: new FormControl(null),
      designation: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$')]),
      phoneCode: new FormControl(null, Validators.required),
      phone: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{10}$')]),
      address: new FormGroup({
        addressLine1: new FormControl(null),
        addressLine2: new FormControl(null),
        postCode: new FormControl(null, [Validators.pattern(/^[a-zA-Z0-9 ]+$/)]),
        countryCode: new FormGroup({
          countryCode: new FormControl(null)
        }),
        stateProvinceCode: new FormControl(null),
        stateProvinceName: new FormControl(null),
        city: new FormControl(null)
      })
    });
    this.parameterId = this.router.getCurrentNavigation()?.extras?.state?.clientId || null;
    // this.selectedCompanyId = this.parameterId == null ? parseInt(sessionStorage.getItem('selectedCompanyId')) : parseInt(this.parameterId);


  }

  ngOnInit() {
    if(sessionStorage.getItem('userTypeRole') === 'Attorney' && sessionStorage.getItem('selectedCompanyName')){
      this.isPrimaryContact = true;
    } else {
      this.isPrimaryContact = false;
    }
    this.cacheCountryService.getCachedCountryList()
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(data => {
        if (data.listCountries.length > 0) {
          this.listCountry = data.listCountries.map((c)=>{
            c['labelWithCode'] = `${c.countryName} - ${c.phoneCode}`;
            return c;
          });
        }
      });
    
    
    // IM-5325 : To resolve duplicate entry and screen freeze issue
    if (sessionStorage.getItem('user')) {
      if(sessionStorage.getItem('currentPrimary')){
        this.isEnabledPrimary = true;
      } else {
        this.isEnabledPrimary = false;
      }
      this.editedUser = JSON.parse(sessionStorage.getItem('user'));
      this.currentUserId = this.editedUser.id;
      this.currentCompanyId = this.editedUser.company.id;
      this.currentUserSignature = this.editedUser.signImage;
      let eventTemp: any = {};
      if(this.editedUser.isAuthSignatory == 1){
        this.userSignatory = true;
        eventTemp.checked = true;
      }
      this.convertBase64(this.editedUser.signImage);
      this.employee.id = this.editedUser.id;
      this.isDisabled = true;
      const defaultCompanyAddress = this.editedUser && this.editedUser.company.address.filter((addr)=> addr.type.code === 'MAIL');
      const address = this.editedUser.address ? this.editedUser.address : defaultCompanyAddress ? defaultCompanyAddress[0] : undefined;
      this.userForm.patchValue({
        companyId: this.editedUser.company.id,
        firstName: this.editedUser.firstName,
        lastName: this.editedUser.lastName,
        middleName: this.editedUser.middleName,
        designation: this.editedUser.designation,
        email: this.editedUser.emailContacts && (this.editedUser.emailContacts as any[]).length > 0 ?
          this.editedUser.emailContacts.find(x => x.email).email : null,
        phoneCode: this.editedUser.phoneContacts &&
          (this.editedUser.phoneContacts as any[]).length > 0 ?
          this.editedUser.phoneContacts.find(x => x.type.code === 'MOBL')?.countryCode?.countryCode :
          null,
        phone: this.editedUser.phoneContacts &&
          (this.editedUser.phoneContacts as any[]).length > 0 ?
          this.editedUser.phoneContacts.find(x => x.phoneNo).phoneNo : null,
        address: address ? address : new Address({})
      });
      if(address){
        const stateType = address.stateProvinceCode ? 'code' : 'name';
        this.handleCountryChange(address.countryCode.countryCode, {value: address.stateProvinceCode ? address.stateProvinceCode : address.stateProvinceName, type:stateType, length:2 });
      }else{
        this.handleCountryChange('USA');
      }

      this.employee.companyId = this.editedUser.company.id;
      this.employee.firstName = this.editedUser.firstName;
      this.employee.lastName = this.editedUser.lastName;
      this.employee.middleName = this.editedUser.middleName;
      this.employee.designation = this.editedUser.designation;
      this.employee.address = this.userForm.value.address;
      // sessionStorage.setItem('employeeId', this.editedUser['id']);
      this.employee.email =
        this.editedUser.emailContacts && (this.editedUser.emailContacts as any[]).length > 0 ?
          this.editedUser.emailContacts.find(x => x.email).email : null;
      this.employee.phone = this.editedUser.phoneContacts &&
        (this.editedUser.phoneContacts as any[]).length > 0 ?
        this.editedUser.phoneContacts.find(x => x.phoneNo).phoneNo : null;
      this.employee.phoneCode = this.editedUser.phoneContacts &&
        (this.editedUser.phoneContacts as any[]).length > 0 ?
        this.editedUser.phoneContacts.find(x => x.type.code === 'MOBL')?.countryCode?.countryCode :
        null;
      this.companyApiService.getCompanyHierarchyById(this.employee.companyId)
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe(data => {
          this.listCompany = data;
          this.selectedCompany.emit({
            companyName: this.listCompany.find(x => x.id === this.employee.companyId).companyName,
            companyId: this.employee.companyId,
            employeeId: this.employee.id
          });
        });
    } else {
      let companyId;
      if (['Petitioner', 'Attorney'].includes(sessionStorage.getItem('userTypeRole'))) {
        // companyId = parseInt(sessionStorage.getItem('companyId'));
        companyId = (this.parameterId) ? this.parameterId : parseInt(sessionStorage.getItem('companyId'));
      } else if (sessionStorage.getItem('userTypeRole') === 'Platform') {
        companyId = parseInt(sessionStorage.getItem('selectedCompanyId'));
      }
      if (companyId) {
        this.companyApiService.getCompanyHierarchyById(companyId)
          .pipe(takeUntil(this.observableSubscription$))
          .subscribe(data => {
            this.listCompany = data;
          });
      }
    }
    this.showDdr = true;
    // if (sessionStorage.getItem('userTypeRole') === Roles.PLATFORMADMIN) {
    //   this.showDdr = true;false;
    //   this.userRoleService.getCompanyNameByCompanyId(parseInt(sessionStorage.getItem('selectedCompanyId'))).subscribe(data => {
    //     this.companyName = data['companyName'];
    //     if (sessionStorage.getItem('user')) {
    //       this.selectedCompany.emit({
    //         companyName: data['companyName'],
    //         companyId: data['id'],
    //         employeeId: parseInt(sessionStorage.getItem('empId'))
    //       });
    //     }
    //   });
    // }
    // else {
    //   this.showDdr = true;
    //   this.companyApiService.getCompanyHierarchyById(parseInt(sessionStorage.getItem('companyId'))).subscribe(data => {
    //     this.listCompany = data;
    //     if (sessionStorage.getItem('user')) {
    //       this.selectedCompany.emit({
    //         companyName: this.listCompany.find(x => x['id'] === this.employee.companyId)['companyName'],
    //         companyId: parseInt(sessionStorage.getItem('companyId')),
    //         employeeId: parseInt(sessionStorage.getItem('empId'))
    //       });
    //     }
    //   });
    // }
  }

  ngAfterViewInit() {
    this.userPageService.statusChangeSubScriptionSubjectStep
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((stepNumber: number) => {
        if (stepNumber === 1) {
          this.userPageService.formChangesSubscription = this.userForm.statusChanges
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(() => {
              this.userPageService.formIsDirtySubject.next({
                dirty: this.userForm.dirty,
                formNumber: 1
              });
            });
        }
      });
  }

  convertBase64(data){
    let imageSrc: string = `data:image/png;base64,${data}`;
    let tempFileName = this.extractFileName(imageSrc);
    this.fileName = tempFileName?.fileName;
  }

  extractFileName(base64String: string): { fileName: string; fileContent: Blob } {
    const matches = base64String.match(/^data:(.+);base64,(.*)$/);
    if (!matches || matches.length !== 3) {
      throw new Error("Invalid Base64 string");
    }
   
    const mimeType = matches[1]; // Extract MIME type
    const decodedData = atob(matches[2]); // Decode Base64 content
    const byteNumbers = new Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      byteNumbers[i] = decodedData.charCodeAt(i);
    }
   
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
   
    // Assuming the filename is passed separately or encoded elsewhere
    const fileName = `downloaded.${mimeType.split("/")[1]}`;
    return { fileName, fileContent: blob };
  }

  userDetailsFormSub() {

    if (this.userForm.invalid) {
      return false; // invalid form submission stopped !
    }

    this.employee.firstName = this.userForm.value.firstName;
    this.employee.lastName = this.userForm.value.lastName;
    this.employee.middleName = this.userForm.value.middleName;
    this.employee.designation = this.userForm.value.designation;
    this.employee.email = this.userForm.value.email;
    this.employee.phoneCode = this.userForm.value.phoneCode;
    this.employee.phone = this.userForm.value.phone;
    this.employee.companyId = this.userForm.value.companyId;
    this.employee.address = this.userForm.value.address;
    const payload: any = {
      countryCode: this.employee.phoneCode,
      email: this.employee.email,
      firstName: this.employee.firstName,
      id: this.employee.id ? this.employee.id : '',
      lastName: this.employee.lastName,
      middleName: this.employee.middleName,
      phone: this.employee.phone,
      designation: this.employee.designation,
      address:{ ...this.employee.address, addressTypeCode: 'MAIL'},
      isAuthSignatory: this.userSignatory
    };
    // if (sessionStorage.getItem('userTypeRole') === Roles.PLATFORMADMIN) {
    //   this.userRoleService.saveUser(parseInt(sessionStorage.getItem('selectedCompanyId')), payload).subscribe((response) => {
    //     if (response && response['id']) {
    //       this.toastr.success('Employee details saved');
    //       this.selectedCompany.emit({
    //         companyName: this.companyName,
    //         companyId: parseInt(sessionStorage.getItem('selectedCompanyId')),
    //         employeeId: response['id']
    //       });
    //       this.stepper.next();
    //     }
    //   });
    // } else {
    if(this.isPrimaryContact){
      if(this.isIncludeAssociate){
        this.userRoleService.validatePrimaryContact(this.employee.companyId)
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe((response: any) => { 
          if (response) {
            this.onClickConfirmation(response, payload, this.isIncludeAssociate);
          }
        });
      } else {
        payload.primaryContactPerson = this.isIncludeAssociate
        this.saveUserDetails(payload);
      }
      
    } else {
      this.saveUserDetails(payload);
    }
  }

  saveUserDetails(payload){
    this.userRoleService.saveUser(this.employee.companyId, payload)
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe((response: ImagilityBaseResponse) => {
      if (response && response.data && response.data.id) {
        this.toastr.success(response.message, 'Success');
        this.employee.id = response.data.id;
        if(this.isPrimaryContact){
          this.onClickSave.emit(true);
        } else {
          this.selectedCompany.emit({
            companyName: this.listCompany.find(x => x.id === this.employee.companyId).companyName,
            companyId: this.employee.companyId,
            employeeId: response.data.id
          }); 
          this.userForm.reset(this.userForm.value);
          this.stepper.next();
        }
      }
    });
  }

  onClickConfirmation(item, payload, isIncludeAssociate){
    this.isIncludeAssociate = isIncludeAssociate;
    let data: any = item?.data;
    data.existingPrimary = item?.data?.message;
    data.newPrimary = this.employee.firstName+" "+this.employee.lastName;

      if(data?.confirmFlag!==0){
        const dialogRef = this.dialog.open(PrimaryContactConfirmationComponent, {
          data: data,
          panelClass: 'custom-dialog',
          width: '400px'
        });
     
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            payload.primaryContactPerson = this.isIncludeAssociate
            this.saveUserDetails(payload);
          }
        });
      } else {
        // default save 
        payload.primaryContactPerson = this.isIncludeAssociate
        this.saveUserDetails(payload);
      }
      
 
  }



  companySelected(e) {
    sessionStorage.setItem('selectedCompanyId', e.value);
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleCountryChange(countryCode, stateObj: any = {}) {
    this.apiService.getStates(countryCode).subscribe((states: []) => {
      this.listStates = states;
      const hasStates = this.listStates.length ? true : false;
      this.resetStateOnCountryChange(hasStates);
      if(stateObj.length){
        this.setStateValue(stateObj.value, stateObj.type)
      }
    });
  }

  resetStateOnCountryChange(hasStates:boolean = true) {
    this.userForm.get('address')['controls']['stateProvinceCode'].value = null;
    this.userForm.get('address')['controls']['stateProvinceName'].value = '';
  }

  setStateValue(value:string, type: string){
    if(type === 'code'){
      this.userForm.get('address')['controls']['stateProvinceCode'].value = value;
      this.userForm.get('address')['controls']['stateProvinceCode'].updateValueAndValidity();
    }else{
      this.userForm.get('address')['controls']['stateProvinceName'].value = value;
      this.userForm.get('address')['controls']['stateProvinceName'].updateValueAndValidity();
    }
  }

  includeAssociate(event){
    this.isIncludeAssociate = event.checked;
  }

  isUserSignatory(event){
    this.userSignatory = event.checked;
  }

  uploadSignature(event: any, signatory: any) {   
    const file: File = event.target.files[0];    
    const formData = new FormData();
    formData.append('file', file);
    if (file) {     
      this.companyApiService.uploadAuthorisedSignatory(this.currentCompanyId, signatory, formData).subscribe(
        (response: any) => {  
          this.beforeDelete = false;        
          this.convertBase64(response?.data?.imgSignature?.signatureImg);
          this.toastr.success('Signature uploaded successfully', 'Success');  
          this.currentUserSignature =  response?.data?.imgSignature?.signatureImg;
        },
        (error) => {          
          this.toastr.error('Signature is not Uploaded');
        }
      );
    }
  }

  base64ToBlob(base64: string, contentType: string = '', sliceSize: number = 512): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }


  confirmDeleteSignatory() {
    this.displayList = true;
  } 

  cancelAction(){
    this.displayList = false;
  }
  
  deleteSignatory(signatoryId: number) {
    this.companyApiService.deleteSignature(this.currentCompanyId, signatoryId).subscribe(
      (response) => {
        this.beforeDelete = true;
        this.toastr.success(response.message, 'Success');
        this.displayList = false;
        this.currentUserSignature = null;
      }, 
      (error) => {
        this.toastr.error('Error deleting signatory', error);
      }
    );
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('currentPrimary');
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }


}
